import React, {useEffect} from 'react';

let player;

const YouTubePlayer = ({videoId}) => {
    const playerRef = React.useRef<any>(null);

    useEffect(() => {
        // 2. This code loads the IFrame Player API code asynchronously.
        const tag = document.createElement('script');

        tag.src = "https://www.youtube.com/iframe_api";

        const firstScriptTag = document.getElementsByTagName('script')[0];

        firstScriptTag?.parentNode?.insertBefore(tag, firstScriptTag);
    }, []);

    useEffect(() => {
        // 3. This function creates an <iframe> (and YouTube player)
        // @ts-ignore
        window.onYouTubeIframeAPIReady = () => {
            // @ts-ignore
            player = new YT.Player('player', {
                height: '390',
                width: '640',
                videoId,
                playerVars: {
                    'playsinline': 1
                },
                events: {
                    'onReady': onPlayerReady,
                }
            });
        };

        // 4. The API will call this function when the video player is ready.
        const onPlayerReady = (event) => {
            event.target.playVideo();
        };

        return () => {
            if (typeof playerRef?.current?.destroy === 'function') {
                playerRef.current.destroy();
            }
        };
    }, [videoId]);

    useEffect(() => {
        if (player) {
            player.loadVideoById(videoId);
        }
    }, [videoId, player]);

    return <div ref={playerRef} id="player"></div>;
};

export default YouTubePlayer;